import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column, List, Icon } from '@pella/sash-framework';
import { Image, CTA } from '../../../../../';
import { isValidArray } from '../../../../../utilities/validations';

const ProMenu = ({ data, ...other }) => (
	<div
		className='proMenu max-h-[calc(100vh-150px)] overflow-auto bg-gray-3 py-9'
		aria-label='Sub Navigation'
		{...other}
	>
		<Container width={1920}>
			<Row className={`2xl:-mx-10 2xl:[&>div]:px-10`}>
				{data.category
					?.find((cat) => cat.category_type === 'feature')
					?.group?.map((feat, index) => (
						<Column
							key={index}
							lg='fluid'
							className='flex flex-col flex-wrap'
						>
							{feat.file?.url && (
								<Image
									data={{ image: feat.file }}
									className='!block h-[200px] w-full object-cover'
								/>
							)}

							{feat.heading && <p className='mt-5 text-lg font-semibold [&_a]:decoration-transparent [&_a]:decoration-1 [&_a]:hover:text-gray-70 [&_a]:hover:decoration-current'>{feat.cta.length === 1 ? <CTA data={feat.cta[0]}>{feat.heading}</CTA> : feat.heading}</p>}

							{feat.subheading && (
								<div
									dangerouslySetInnerHTML={{ __html: feat.subheading }}
									className='mb-7 mt-1'
								/>
							)}

							{feat.cta?.length > 1 &&
								feat.cta.map((cta, index) => (
									<CTA
										data={cta}
										key={index}
										className='no-underline hover:text-gray-80 [&>span:first-child]:flex [&>span:first-child]:items-center'
									>
										<span className='decoration-1 hover:underline'>{cta.link.title}</span>
										<Icon
											name='keyboard_arrow_right'
											size={32}
										/>
									</CTA>
								))}
						</Column>
					))}

				{isValidArray(data.category?.find((cat) => cat.category_type === 'pro type')?.entries) && (
					<Column
						lg={3}
						xxl={2}
					>
						{data.category.find((cat) => cat.category_type === 'pro type').heading && <p className='mb-2 text-xl'>{data.category.find((cat) => cat.category_type === 'pro type').heading}</p>}

						<List
							bullets='none'
							className='grid grid-cols-2 gap-3'
						>
							{data.category
								.find((cat) => cat.category_type === 'pro type')
								.entries.map((cob, index) => (
									<li key={index}>
										<CTA
											data={cob}
											className='group block text-center text-xs leading-tight no-underline [&>span:first-child]:mx-auto [&>span:first-child]:mb-2.5 [&>span:first-child]:flex [&>span:first-child]:aspect-square [&>span:first-child]:w-full [&>span:first-child]:max-w-[100px] [&>span:first-child]:items-center [&>span:first-child]:justify-center [&>span:first-child]:rounded-full [&>span:first-child]:bg-primary [&>span:first-child]:!text-5xl'
										>
											{cob.link?.title && <p className='group-hover:underline'>{cob.link.title}</p>}
										</CTA>
									</li>
								))}
						</List>
					</Column>
				)}

				{isValidArray(data?.category?.find((cat) => cat.category_type === 'resources')?.entries) && (
					<Column lg={2}>
						{data.category?.find((cat) => cat.category_type === 'resources').heading && <p className='mb-2 text-xl'>{data.category?.find((cat) => cat.category_type === 'resources').heading}</p>}

						<List bullets='none'>
							{data.category
								?.find((cat) => cat.category_type === 'resources')
								.entries.map((link, index) => (
									<li
										key={index}
										className='leading-snug'
									>
										<CTA
											data={link}
											className='inline-block px-0 py-1 decoration-transparent decoration-1 hover:decoration-current'
										/>
									</li>
								))}
						</List>
					</Column>
				)}

				{isValidArray(data?.category?.find((cat) => cat.category_type === 'tools')?.entries) && (
					<Column lg={2}>
						{data.category?.find((cat) => cat.category_type === 'tools').heading && <p className='mb-2 text-xl'>{data.category?.find((cat) => cat.category_type === 'tools').heading}</p>}

						<List bullets='none'>
							{data.category
								?.find((cat) => cat.category_type === 'tools')
								.entries.map((link, index) => (
									<li
										key={index}
										className='leading-snug'
									>
										<CTA
											data={link}
											className='inline-block px-0 py-1 decoration-transparent decoration-1 hover:decoration-current'
										/>
									</li>
								))}
						</List>
					</Column>
				)}
			</Row>
		</Container>
	</div>
);

ProMenu.propTypes = {
	data: PropTypes.object,
};

export default ProMenu;
